// extracted by mini-css-extract-plugin
export default {"authModal":"ModalSignInForm_authModal__k3VDZ","sigInForm":"ModalSignInForm_sigInForm__poMOC","closeModal":"ModalSignInForm_closeModal__2QRJ6"};